import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  question: string;
  answer: string;
  is_active: boolean;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const addQuestion = async (payload: APIPayload) => {
  try {
    const response = await Axios.post(`/questions`, payload);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useAddQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => addQuestion(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['get_predefined_question'] });
      console.log(data);
    },
    onError: (error) => {
      toast.error('Adding Question Failed', { description: error.message });
    },
  });
};
